import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { AllState } from '../../store'

// 指定した externalId の application_function の uuid を解決する。
// 当該機能の権限が無いユーザーの場合は '' を返す。
export const useApplicationFunctionUuid = (externalId: string): string => {
  const functions = useSelector(
    (state: AllState) => state.appFunction.functions
  )
  return useMemo(
    () => functions.find(f => f.externalId === externalId)?.uuid || '',
    [functions, externalId]
  )
}
